import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { IProduct, IVariant } from 'src/app/features/produits/models/products.models';
import { environment } from 'src/environments/environment';
import { customValidator } from 'src/app/shared/validators/fields-validators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custome-override',
  templateUrl: './custome-override.component.html',
  styleUrls: ['./custome-override.component.scss']
})
export class CustomeOverrideComponent implements OnInit {

  form!: FormGroup;
  baseUrl = environment.BASE_URL_API;
  constructor(
    public dialogRef: MatDialogRef<CustomeOverrideComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      increment: new FormControl(this.data?.increment ?? 1, [Validators.required]),
      max_qte: new FormControl(this.data?.max_qte ?? null),
      min_qte: new FormControl(this.data?.min_qte ?? 1, [Validators.required]),
      can_be_sold_out_of_stock: new FormControl(this.data?.can_be_sold_out_of_stock ?? false, [Validators.required]),
      id: new FormControl(this.data?.id),
    }, { validators: customValidator(this.translate) });
  }

  sanitize(event: any) {
    event.target.value = event.target.value.replace(/[^\d]/g, '');
  }

  save(): void | boolean {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return false
    }
    this.dialogRef.close(this.form.value)
  }

  closed(){
    this.dialogRef.close()

  }

}
